<div *ngIf="isLoading" class="overlay"></div>
<div *ngIf="isLoading" class="loader"></div>
<div class="example-inner">
  <div class="container">
    <div class="header">
        <button mat-raised-button 
              color="primary" 
              class="dashboard-button" 
              routerLink="/sales/generaldash">
        <mat-icon>dashboard</mat-icon>
        <span>Sales Dashboard</span>
        </button>
        <h1 class="page-title" >Sales Files Import</h1>
    </div>
  <kendo-grid
    [data]="gridData | async"
    [height]="750"
    [pageSize]="gridState.take"
    [skip]="gridState.skip"
    [sort]="gridState.sort"
    [sortable]="true"
    [pageable]="true"
    scrollable="none"
    [filterable]="true"
    [filter]="gridState.filter"
    (dataStateChange)="dataStateChange($event)"
    (edit)="updateWatch($event)"
    (add)="createWatch()"
  >
    <ng-template kendoGridToolbarTemplate>
      <button kendoGridAddCommand>Add new</button>
    </ng-template>
    <kendo-grid-column field="name" title="Name"></kendo-grid-column>
    <kendo-grid-column field="stoer" title="Store"></kendo-grid-column>
    <kendo-grid-column field="description" title="Description" [sortable]="false"></kendo-grid-column>
    <kendo-grid-column field="dateModified" title="Date Modified" [sortable]="false"></kendo-grid-column>
    <kendo-grid-column field="imported" title="Imported" [sortable]="false"></kendo-grid-column>
    <kendo-grid-column field="importDate" title="Import Date" [sortable]="false"></kendo-grid-column>
    <kendo-grid-command-column title="Actions" [width]="220">
      <ng-template kendoGridCellTemplate>
        <button kendoGridEditCommand [primary]="true">Edit</button>
        <button kendoGridRemoveCommand>Delete</button>
      </ng-template>
    </kendo-grid-command-column>
  </kendo-grid>
</div>
</div>
